var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	5036: () => (loadSingletonVersion("default", "react", true, [4,19,2,7], () => (() => (__webpack_require__(65043))))),
	79643: () => (loadSingletonVersion("default", "@reduxjs/toolkit", false, [4,2,12,0], () => (Promise.all([__webpack_require__.e(1745), __webpack_require__.e(673)]).then(() => (() => (__webpack_require__(70673))))))),
	19460: () => (loadSingletonVersion("default", "react-redux", false, [4,9,3,0], () => (__webpack_require__.e(3003).then(() => (() => (__webpack_require__(83003))))))),
	39100: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-constants", false, [4,0,1,82], () => (__webpack_require__.e(6588).then(() => (() => (__webpack_require__(26588))))))),
	28392: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-frontend", false, [4,1,11,6], () => (Promise.all([__webpack_require__.e(5916), __webpack_require__.e(5795), __webpack_require__.e(6803), __webpack_require__.e(9643), __webpack_require__.e(9460), __webpack_require__.e(9100), __webpack_require__.e(5498), __webpack_require__.e(3707)]).then(() => (() => (__webpack_require__(76803))))))),
	95498: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-api-client-web-trading", false, [4,2,0,52], () => (__webpack_require__.e(3710).then(() => (() => (__webpack_require__(63710))))))),
	86855: () => (loadSingletonVersion("default", "dayjs", false, [4,1,11,21], () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(60446))))))),
	92684: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-api-client-market-data-ws", false, [4,1,0,11], () => (__webpack_require__.e(8566).then(() => (() => (__webpack_require__(88566))))))),
	15500: () => (loadSingletonVersion("default", "js-cookie", false, [1,3,0,7], () => (__webpack_require__.e(1880).then(() => (() => (__webpack_require__(1880))))))),
	89039: () => (loadSingletonVersion("default", "react-dom", false, [4,19,2,7], () => (__webpack_require__.e(5569).then(() => (() => (__webpack_require__(97950))))))),
	60668: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-instruments", false, [4,1,2,44], () => (Promise.all([__webpack_require__.e(105), __webpack_require__.e(9100), __webpack_require__.e(5498), __webpack_require__.e(6855)]).then(() => (() => (__webpack_require__(105))))))),
	50340: () => (loadSingletonVersion("default", "styled-components", false, [4,6,4,2], () => (Promise.all([__webpack_require__.e(3354), __webpack_require__.e(4406)]).then(() => (() => (__webpack_require__(53354))))))),
	56424: () => (loadSingletonVersion("default", "react-router", false, [4,7,16,0], () => (__webpack_require__.e(7456).then(() => (() => (__webpack_require__(97456))))))),
	22883: () => (loadSingletonVersion("default", "i18next", false, [4,26,3,0], () => (__webpack_require__.e(4978).then(() => (() => (__webpack_require__(44978))))))),
	4197: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-marketdata", false, [4,1,1,42], () => (Promise.all([__webpack_require__.e(67), __webpack_require__.e(7171), __webpack_require__.e(9100), __webpack_require__.e(5498), __webpack_require__.e(2684)]).then(() => (() => (__webpack_require__(37171))))))),
	37237: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-frontend-hooks", false, [4,1,0,29], () => (__webpack_require__.e(2612).then(() => (() => (__webpack_require__(72612))))))),
	503: () => (loadSingletonVersion("default", "@grafana/faro-web-tracing", false, [1,2,7,0], () => (__webpack_require__.e(4663).then(() => (() => (__webpack_require__(84663))))))),
	3289: () => (loadSingletonVersion("default", "react-device-detect", false, [4,2,2,3], () => (__webpack_require__.e(8738).then(() => (() => (__webpack_require__(8738))))))),
	8299: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-client", false, [4,1,9,55], () => (Promise.all([__webpack_require__.e(67), __webpack_require__.e(9266), __webpack_require__.e(3707)]).then(() => (() => (__webpack_require__(19266))))))),
	13861: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-accounts", false, [4,2,1,36], () => (Promise.all([__webpack_require__.e(67), __webpack_require__.e(3731)]).then(() => (() => (__webpack_require__(43731))))))),
	22746: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-orders", false, [4,1,0,13], () => (Promise.all([__webpack_require__.e(67), __webpack_require__.e(3820)]).then(() => (() => (__webpack_require__(63820))))))),
	23592: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-subscriptions", false, [4,0,1,0], () => (Promise.all([__webpack_require__.e(236), __webpack_require__.e(6186)]).then(() => (() => (__webpack_require__(83805))))))),
	37902: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-design-system", false, [4,0,88,21], () => (Promise.all([__webpack_require__.e(294), __webpack_require__.e(4499), __webpack_require__.e(4406), __webpack_require__.e(1041), __webpack_require__.e(1861)]).then(() => (() => (__webpack_require__(4499))))))),
	42795: () => (loadSingletonVersion("default", "@grafana/faro-react", false, [1,2,7,0], () => (__webpack_require__.e(5168).then(() => (() => (__webpack_require__(65168))))))),
	51148: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-watchlists", false, [4,1,3,49], () => (__webpack_require__.e(9707).then(() => (() => (__webpack_require__(99707))))))),
	56419: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-module", false, [4,1,2,16], () => (__webpack_require__.e(3148).then(() => (() => (__webpack_require__(50767))))))),
	64675: () => (loadSingletonVersion("default", "@cmctechnology/semantic-conventions", false, [1,1,2,1], () => (__webpack_require__.e(9078).then(() => (() => (__webpack_require__(79078))))))),
	68841: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-messages", false, [4,1,0,16], () => (__webpack_require__.e(4020).then(() => (() => (__webpack_require__(1639))))))),
	70952: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-account-management", false, [4,0,2,5], () => (Promise.all([__webpack_require__.e(7196), __webpack_require__.e(3707)]).then(() => (() => (__webpack_require__(7196))))))),
	71475: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-analytics", false, [4,2,1,34], () => (__webpack_require__.e(3307).then(() => (() => (__webpack_require__(93307))))))),
	74120: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-charts", false, [4,1,6,31], () => (__webpack_require__.e(2128).then(() => (() => (__webpack_require__(62128))))))),
	75754: () => (loadSingletonVersion("default", "react-i18next", false, [4,17,0,8], () => (__webpack_require__.e(6930).then(() => (() => (__webpack_require__(76930))))))),
	82932: () => (loadSingletonVersion("default", "usehooks-ts", false, [4,3,1,1], () => (__webpack_require__.e(6864).then(() => (() => (__webpack_require__(54483))))))),
	83067: () => (loadSingletonVersion("default", "i18next-xhr-backend", false, [4,3,2,2], () => (__webpack_require__.e(3548).then(() => (() => (__webpack_require__(1167))))))),
	85484: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-exchange", false, [4,1,7,9], () => (Promise.all([__webpack_require__.e(5916), __webpack_require__.e(7236), __webpack_require__.e(3707)]).then(() => (() => (__webpack_require__(37236))))))),
	64406: () => (loadSingletonVersion("default", "stylis", false, [4,4,4,0], () => (__webpack_require__.e(8312).then(() => (() => (__webpack_require__(98312))))))),
	57282: () => (loadSingletonVersion("default", "react-select", false, [4,5,10,2], () => (__webpack_require__.e(2364).then(() => (() => (__webpack_require__(2364))))))),
	96748: () => (loadSingletonVersion("default", "lodash.merge", false, [4,4,6,2], () => (__webpack_require__.e(6819).then(() => (() => (__webpack_require__(16819))))))),
	43707: () => (loadSingletonVersion("default", "@forgerock/javascript-sdk", false, [4,4,9,1], () => (Promise.all([__webpack_require__.e(1745), __webpack_require__.e(2202)]).then(() => (() => (__webpack_require__(22202))))))),
	236: () => (loadSingletonVersion("default", "@cmctechnology/webinvest-store-frontend", false, [4,1,11,6], () => (Promise.all([__webpack_require__.e(5916), __webpack_require__.e(5795), __webpack_require__.e(8447), __webpack_require__.e(9100), __webpack_require__.e(5498), __webpack_require__.e(3707)]).then(() => (() => (__webpack_require__(78447)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"236": [
		236
	],
	"340": [
		50340
	],
	"668": [
		60668
	],
	"1041": [
		57282,
		96748
	],
	"2684": [
		92684
	],
	"2883": [
		22883
	],
	"3707": [
		43707
	],
	"4197": [
		4197
	],
	"4406": [
		64406
	],
	"5036": [
		5036
	],
	"5498": [
		95498
	],
	"5500": [
		15500
	],
	"6424": [
		56424
	],
	"6855": [
		86855
	],
	"7237": [
		37237
	],
	"7244": [
		503,
		3289,
		8299,
		13861,
		22746,
		23592,
		37902,
		42795,
		51148,
		56419,
		64675,
		68841,
		70952,
		71475,
		74120,
		75754,
		82932,
		83067,
		85484
	],
	"8392": [
		28392
	],
	"9039": [
		89039
	],
	"9100": [
		39100
	],
	"9460": [
		19460
	],
	"9643": [
		79643
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}